((app, ng) => {

    app.component("accountTimeline",
        {
            templateUrl: "/App/Client/Case/Accounts/AccountTimeline/account-timeline.html",
            controller: accountTimelineController,
            bindings: {
                insuranceAccountId: "<",
                investmentAccountId: "<",
                timelineStatuses: "<",
                accountStatuses: "<",
            }
        });

    function accountTimelineController(caseModalService) {
        const $ctrl = this;

        const editAccountStatus = (statusName, $event) => {
            let status = $ctrl.accountStatuses.find(stat => { return stat.Status === statusName });

            if (!status) {
                status = {
                    InsuranceAccountId: $ctrl.insuranceAccountId,
                    InvestmentAccountId: $ctrl.investmentAccountId,
                    Status: statusName,
                }
            }

            caseModalService.openEditAccountStatus({ ...status }, $event).then(response => {
                if (!!response) {
                    switch (response.evt) {
                        case "STATUS_ADDED":
                            {
                                const date = new Date(response.status.StatusDate);
                                response.status.StatusDate = date;
                                $ctrl.accountStatuses.push(response.status);
                                break;
                            }
                        case "STATUS_UPDATED":
                            {
                                const date = new Date(response.status.StatusDate);
                                status.StatusDate = date;
                                break;
                            }
                        case "STATUS_DELETED":
                            {
                                $ctrl.accountStatuses.splice(1, $ctrl.accountStatuses.findIndex(stat => stat.Id === response.statusId));
                                break;
                            }
                    }
                }
            });
        }

        ng.extend($ctrl,
            {
                editAccountStatus,
            });
    }

})(window.app, window.angular);